import './license-info-modal.css';
